import { getLeafValue } from "../../helper";
export const sortByExplicitOrder = (field, order) => {
    const rank = new Map(order.map((label, index) => [label, index]));
    return (args, a, b) => {
        const va = getLeafValue(a.datapoints?.find((d) => d.name === field)?.value)?.toString() || "";
        const vb = getLeafValue(b.datapoints?.find((d) => d.name === field)?.value)?.toString() || "";
        const ai = rank.get(va);
        const bi = rank.get(vb);
        const ra = ai === undefined ? Number.MAX_SAFE_INTEGER : ai;
        const rb = bi === undefined ? Number.MAX_SAFE_INTEGER : bi;
        return ra - rb;
    };
};
